<template>
  <div class="cds-guide">
    <h1 class="f4">{{ $t('Adding your content to SpringboardVR is a 4 step process:') }}</h1>
    <div class="steps">
      <div class="step">
        <div class="label">{{ $t('Step 1:') }}</div>
        <div class="value">{{ $t('Content Details -  Fill out the details for your title') }}</div>
      </div>
      <div class="step" v-if="!this.$permissions['enterprise-developer']">
        <div class="label">{{ $t('Step 2:') }}</div>
        <div class="value">{{ $t('Pricing & Distribution - Set pricing for your title') }}</div>
      </div>
      <div class="step" v-if="!this.$permissions['enterprise-developer']">
        <div class="label">{{ $t('Step 3:') }}</div>
        <div
          class="value"
        >{{ $t('End User License Agreement - Protect your intellectual property') }}</div>
      </div>
      <div class="step">
        <div class="label">{{ $t('Step 4:') }}</div>
        <div
          class="value"
        >{{ $t('Content Distribution Upload - Upload your content to our servers') }}</div>
      </div>
    </div>
    <div class="flex">
      <div class="w-50 mr4">
        <UIButton
          class="db w-100 mb3"
          href="https://svr.li/k/363"
          target="_blank"
          rel="noopener"
          icon="external-link"
        >{{ $t('Content Distribution Guide') }}</UIButton>
        <p
          class="f-instructions"
        >{{ $t('This guide walks you through the upload process, including pricing details, distribution options and more.') }}</p>
      </div>
      <div class="w-50">
        <UIButton
          secondary
          class="db mb3 w-100"
          href="https://svr.li/k/361"
          target="_blank"
          rel="noopener"
          icon="external-link"
        >{{ $t('Content Guidelines') }}</UIButton>
        <p
          class="f-instructions"
        >{{ $t('These guidelines lay out both the categories of content we’re actively looking for and the type of content that isn’t a good fit for our platform.') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import UIButton from '@/core/shared/components/ui/UIButton';
export default {
  components: {
    UIButton,
  },
};
</script>

<style lang="postcss" scoped>
@import "core/shared/styles";

.cds-guide {
  & .steps {
    margin: var(--spacingMd) 0;
  }

  & .step {
    @apply --f5;
    margin-bottom: var(--spacingSm);

    &:last-child {
      margin-bottom: 0;
    }

    & .label {
      display: inline;
      margin-right: var(--spacingXS);
      color: var(--colorSBRedFlat);
      font-weight: bold;
    }

    & .value {
      display: inline;
    }
  }
}
</style>
